<template>
  <v-btn
    rounded
    elevation="0"
    outlined
    color="secondary"
    dark
    @click="signOut()"
    >Salir</v-btn
  >
</template>
<script>
export default {
  name: 'SignOutButton',
  methods: {
    signOut() {
      this.$store.dispatch('auth/signOut');
    }
  }
};
</script>
